import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RESOURCES } from '@/constants/routes';

// Trucks became resources (ENG-6065) and are managed on the Resources page now. The tab stays on
// the account page where operators are used to finding it, but it has no content of its own:
// selecting it goes to Resources.
export const TRUCKS_TAB = 'Trucks';

// The `onSelect` for an account page's <Tabs>. Every other tab selects as normal.
export const useTrucksTab = () => {
    const navigate = useNavigate();

    return useCallback(
        (key) => {
            if (key === TRUCKS_TAB) navigate(RESOURCES);
        },
        [navigate]
    );
};
